import { proxy } from 'valtio';

export type AifcDebugSelectionsState = {
  selectedEntireFields: string[];
  selectedEntireEntries: string[];
  selectedValues: { entryId: string; fieldId: string }[];
};

function hasChanged<T>(prev: T[], next: T[]): boolean {
  if (prev.length !== next.length) {
    return true;
  }

  for (let i = 0; i < prev.length; i++) {
    if (prev[i] !== next[i]) {
      return true;
    }
  }

  return false;
}

const createAifcDebugSelectionsState = () => {
  const state: AifcDebugSelectionsState = proxy({
    selectedEntireFields: [],
    selectedEntireEntries: [],
    selectedValues: []
  });

  const setAifcDebugSelectionsState = (next: AifcDebugSelectionsState) => {
    if (hasChanged(state.selectedEntireFields, next.selectedEntireFields)) {
      state.selectedEntireFields = next.selectedEntireFields;
    }

    if (hasChanged(state.selectedEntireEntries, next.selectedEntireEntries)) {
      state.selectedEntireEntries = next.selectedEntireEntries;
    }

    if (hasChanged(state.selectedValues, next.selectedValues)) {
      state.selectedValues = next.selectedValues;
    }
  };

  const resetAifcDebugSelectionsState = () => {
    state.selectedEntireFields = [];
    state.selectedEntireEntries = [];
    state.selectedValues = [];
  };

  return {
    state,
    setAifcDebugSelectionsState,
    resetAifcDebugSelectionsState
  };
};

export const aifcDebugSelectionsState = createAifcDebugSelectionsState();
